<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Categories Group
            <div class="settings-header__btn">
              <el-button
              @click="routerLink('settings-dashboard')"
              type="success"
              size="mini"
              >Setting Dashboard</el-button>
            </div>
          </div>
          <div class="wrap__tree">

            <div class="nav-tree">
              <el-button
                @click="openModalAdd"
                class="nav-tree__item"
                size="mini"
                type="primary"
                plain
                icon="el-icon-plus"
                >Add Categories Group</el-button>
            </div>

            <el-table
              max-height="650"
              :data="tableData"
              :empty-text="$t('general_noData')"
              style="width: 100%">
              <el-table-column
                label="ID"
                type="index"
                align="center"
                width="70">
              </el-table-column>
              <el-table-column
                prop="code"
                label="Code"
                width="140">
              </el-table-column>
              <el-table-column
                prop="name"
                label="Name">
              </el-table-column>
              <el-table-column
                width="120"
                label="Action">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-edit"
                    @click="handleEdit(scope.row)"></el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    @click="handleDelete(scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </div>
      </div>
    </div>

    <!-- add & edit modal -->
    <sweet-modal blocking :title="isCreate ? 'Add Categories Group' : 'Edit Categories Group'" ref="modal" class="modal" v-on:close="closeModal">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="name">
              <el-input label="Name" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="code">
              <el-input label="Code" v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
          <el-button v-if="isCreate" @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
          <el-button v-else @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

  </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: "CategoriesGroup",
  components: {
    SweetModal
  },
  data() {
    return {
      isCreate: true,
      tableData: [],
      selectedRowId: '',
      form:{
        name: '',
        code: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    async loadList(){
      let loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/itemCategoryGroup/list?companyId=${this.$route.query.companyId}`)
        this.tableData = data.list
      } catch (error) {
        console.log('An error occurred:', error)
      } finally {
        loader.hide()
      }
    },
    addItem(form){
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let loader = this.$loading.show()
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/itemCategoryGroup/create?companyId=${this.$route.query.companyId}`, this.form)
            this.$refs.modal.close()
            await this.loadList()
          } catch (error) {
            console.log('An error occurred:', error)
          } finally {
            loader.hide()
          }
        } else {
          console.log('error submit!')
          return false
        }
      })
    },
    openModalAdd(){
      this.isCreate = true
      this.$refs.modal.open()
    },
    closeModal(){
      this.$refs['form'].resetFields();
    },
    async handleEdit(row) {
      this.isCreate = false
      this.selectedRowId = row.id

      let loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/itemCategoryGroup/item?id=${row.id}&companyId=${this.$route.query.companyId}`)
        this.form.name = data.inventory.name
        this.form.code = data.inventory.code
        this.$refs.modal.open()
      } catch (error) {
        console.log('An error occurred:', error)
      } finally {
        loader.hide()
      }
    },
    editItem(form){
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let loader = this.$loading.show()
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/itemCategoryGroup/update?id=${this.selectedRowId}&companyId=${this.$route.query.companyId}`, this.form)
            this.$refs.modal.close()
            await this.loadList()
          } catch (error) {
            console.log('An error occurred:', error)
          } finally {
            loader.hide()
          }
        }else {
          console.log('Error submit!')
          return false
        }
      });
    },
    handleDelete(row) {
      this.selectedRowId = row.id

      this.$confirm('This will permanently delete the Categories Group. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(async () => {

        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.delete(`/api/v1/itemCategoryGroup/delete?id=${this.selectedRowId}&companyId=${this.$route.query.companyId}`)
          this.$message({ type: 'success', message: 'Delete completed' })
          await this.loadList()
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }

      }).catch(() => {
        this.$message({ type: 'info', message: 'Delete canceled' });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
